import './css/app.scss'
import accordian from './ts/accordian'
import copyAdv from './ts/copyAdv'
import dropdown from './ts/dropdowns'
import lazyLoad from './ts/lazyLoad'
import loadSprite from './ts/loadSprite'
import mobMenu from './ts/mobMenu'
import './ts/neto.js'
import popups from './ts/popups'
import printPDF from './ts/printPDF'
import readMore from './ts/readmore'
import sliders from './ts/slider'
import stickyHeader from './ts/stickyHeader'

import feqAccordian from './ts/faqAccordian'
import setHeight from './ts/setHeight'

loadSprite.init()
lazyLoad.init()
copyAdv.init()
sliders.init()
readMore.init()
popups.init()
accordian.init()
dropdown.init()
mobMenu.init()
stickyHeader.init()

printPDF.init()
feqAccordian.init()
setHeight.init()
window.resetEvent = new Event('reset')
